import GridTile from "../grid/GridTile";
import WorldGrid from "../grid/WorldGrid";
import ShadowCastCallback from "./ShadowCastCallback";

const dirs = [
    [0, -1],
    [1, 0],
    [0, 1],
    [-1, 0]
];

/**
 * @abstract
 */
export default class ShadowCaster {
    /**
     * 
     * @param {WorldGrid} worldGrid 
     */
    constructor(worldGrid) {
        /**
         * @constant
         * @type {WorldGrid}
         */
        this.worldGrid = worldGrid;
    }

    /**
     * Cast shadows in the grid.
     *
     * @abstract
     * @param {GridTile} tile     The center tile.
     * @param {number} tileRadius The radius of the light (in tiles, not pixels).
     * @param {ShadowCastCallback} callback The callback that will be invoked once for every tile that has light cast upon it.
     */
    castShadows(tile, tileRadius, callback) {}
    
    /**
     * @param {number} radius 
     * @returns {number}
     */
    getNeighborCountForRadius(radius) {
        return radius * 8; // The number of neighbors increases by 8 for every increment of radius.
    }

    /**
     * Return all tiles in a concentric ring
     * @param {number} centerCol
     * @param {number} centerRow
     * @param {number} radius
     * @param {ShadowCastCallback} callback The callback that will be invoked once for every tile that has light cast upon it.
     */
    forEachCircleTile(centerCol, centerRow, radius, callback) {
        const countFactor = 2;
        const startOffsetCol = -1;
        const startOffsetRow = 1;

        // starting tile
        let tileCol = centerCol + startOffsetCol * radius;
        let tileRow = centerRow + startOffsetRow * radius;

        let prevTile = null;

        // The number of neighbors increases by 8 for every increment of radius.
        const neighborCount = this.getNeighborCountForRadius(radius);
        let neighborIndex = 0;

        for (let i = 0; i < dirs.length; i++) {
            for (let j = 0; j < radius * countFactor; j++) {
                // Note: this sometimes adds null to the result!
                let tile;
                if (prevTile != null) {
                    // See if we can find the tile in the same region as the previous tile.
                    tile = prevTile.getNeighborColRow(tileCol, tileRow);
                }
                else {
                    tile = this.worldGrid.getGridTile(tileCol, tileRow);
                }

                if (tile) {
                    if (!this.onCircleTile(tile, neighborIndex, neighborCount, radius, callback)) {
                        return;
                    }
                }
                neighborIndex++;

                tileCol += dirs[i][0];
                tileRow += dirs[i][1];

                prevTile = tile;
            }
        }
    }

    /**
     * @abstract
     * @param {GridTile} tile
     * @param {number} neighborIndex
     * @param {number} neighborCount
     * @param {number} radius
     * @param {ShadowCastCallback} callback The callback that will be invoked once for every tile that has light cast upon it.
     * @returns {boolean}
     */
    onCircleTile(tile, neighborIndex, neighborCount, radius, callback) {}

}